export default ({ app }, inject) => {
    inject('filterEmptyRelations', filterEmptyRelations);
    inject('filterEmptyElements', filterEmptyElements);
    inject('getRedirectUrl', getRedirectUrl);
    inject('removeParagraphs', removeParagraphs);
    inject('roundHalf', roundHalf);
    inject('truncateString', truncateString);
    inject('formatId', formatId);
    inject('getPaymentLogo', getPaymentLogo);
    inject('getPaymentLogoHtml', getPaymentLogoHtml);
    inject('getMobilePaymentLogoHtml', getMobilePaymentLogoHtml);

    inject('getApplySecurelyString', (card) => {
        let applySecurelyString = app.$translate('secure_application_at_company', 'Ansök säkert hos {company}');
        return applySecurelyString.replace('{company}', card.data.company_name);
    });
};

const filterEmptyRelations = (relation) => {
    let key = Object.keys(relation)[0];
    return relation[key] && relation[key].id;
};

const filterEmptyElements = (element) => {
    let key = Object.keys(element)[0];
    return element[key];
};

const getRedirectUrl = (card, placement, position) => {

    if (placement && position && position > 0) {
        return `/out/${card.uid}/?placement=${placement}&position=${position}`;
    }

    if (placement) {
        return `/out/${card.uid}/?placement=${placement}`;
    }

    if (position && position > 0) {
        return `/out/${card.uid}/?position=${position}`;
    }

    return `/out/${card.uid}/`;
};

const removeParagraphs = (string) => {
    return string.replace('<p>', '').replace('</p>', '');
};

const roundHalf = (num) => {
    return Math.round(num * 2) / 2;
};

const truncateString = (string, length = 0) => {

    if (length === 0) {
        return string;
    }

    if (string.length > length - 10) {
        return string.substring(0, length) + '...';
    }

    return string;
};

const formatId = (id) => {
    return id.replaceAll('$', '-');
};

const getPaymentLogo = (payment) => {
    const logos = {
        visa: '/payments/visa-logo.png',
        mastercard: '/payments/mastercard-logo.png',
        amex: '/payments/amex-logo.png',
    };
    return logos[payment] 
        ? { 
            image: logos[payment], 
            alt: `${payment} logo` 
        } 
        : null;
};

const getPaymentLogoHtml = (payment, width = 35) => {
    const logo = getPaymentLogo(payment);
    if (!logo) {
        return null;
    }
    return `<img 
        src="${logo.image}" 
        alt="${logo.alt}" 
        class="payment-network-logo" 
        width="${width}"
        loading="lazy"
    >`;
};

const getMobilePaymentLogo = (payment) => {
    const logos = {
        google: '/payments/google-pay.png',
        apple: '/payments/apple-pay.png',
        samsung: '/payments/samsung-pay.png',
    };
    return logos[payment] 
        ? { 
            image: logos[payment], 
            alt: `${payment} pay` 
        } 
        : null;
};

const getMobilePaymentLogoHtml = (payment, height = 14) => {
    const logo = getMobilePaymentLogo(payment);
    if (!logo) {
        return null;
    }
    return `<img 
        src="${logo.image}" 
        alt="${logo.alt}" 
        class="mobile-payment-logo" 
        height="${height}" 
        loading="lazy"
    >`;
};
